import { leerConfiguracion, type ConfiguracionPanel } from '../../config';

/**
 * ¿Ofrece el panel el cobro de la cuota? **Depende del entorno (G1427, ADR-0308):**
 *
 * - **Preproducción** (`VITE_ENTORNO=pre`): **sí**, contra Stripe Billing en modo de pruebas (G1049). La pantalla del plan
 *   enseña contratar, cambiar el método de pago, pagar lo pendiente, anular la baja, la pausa y la baja, y llama a sus
 *   operaciones (`api/ops/plan.ts`), con los dos pasos en el momento en la baja (`x-two-factor: session`, G116).
 * - **Producción** y cualquier otro valor (`pro`, `local`, vacío o desconocido): **no**, hasta la respuesta de la asesoría
 *   fiscal sobre el IVA y Stripe Tax (G92). La pantalla no enseña esos botones ni los llama, y dice `TEXTO_SIN_COBRO`.
 *
 * Sale de la variable de compilación que ya pasa `scripts/desplegar.sh` (`VITE_ENTORNO`, `config.ts`), sin campos nuevos
 * en el contrato de la API: el back ya tiene las operaciones (`modules/Planes/rutas.php`). Cuando llegue G92, se enciende
 * también en `pro` aquí.
 *
 * Con él, además, se elige lo que se contrata (1.15): la elección de la prueba antes de ir al pago, «Añade a tu plan» y la
 * ficha de cada bloque (añadir, unidades y baja) y «Comprar más» (1.16), con nombres y precios del catálogo (`getCatalog`,
 * G1415). La recarga automática de los paquetes de WhatsApp (1.16) no espera a esto (G1416): no cobra por sí sola.
 */
export function cobroDisponible(c: Pick<ConfiguracionPanel, 'entorno'> = leerConfiguracion()): boolean {
    return c.entorno === 'pre';
}

/** Lo que dice la pantalla al propietario mientras el cobro no está (sin fechas: no hay una decidida). */
export const TEXTO_SIN_COBRO = 'Contratar y pagar desde el panel llega pronto. Mientras tanto, si necesitas algo de tu plan, escríbenos.';
